import Grid from "@mui/material/Grid";
import AttributeDisplay from "./AttributeDisplay";
import React from "react";
import {styled} from "@mui/material/styles";
import Paper from "@mui/material/Paper";

const Item = styled(Paper)(({theme}) => ({
    backgroundColor: '#fff', ...theme.typography.body2, padding: 4, height: '100%', textAlign: 'center', color: '#000',
}));

export default function AttributesDisplay() {

    return <Grid container style={{paddingTop: 4, paddingBottom: 4, alignItems: "stretch"}}
                 spacing={1}>
        <Grid item xs={6} sm={4}>
            <Item>
                <AttributeDisplay attribute={'ges'}/>
            </Item>
        </Grid>
        <Grid item xs={6} sm={4}>
            <Item>
                <AttributeDisplay attribute={'str'}/>
            </Item>
        </Grid>
        <Grid item xs={6} sm={4}>
            <Item>
                <AttributeDisplay attribute={'zae'}/>
            </Item>
        </Grid>
        <Grid item xs={6} sm={4}>
            <Item>
                <AttributeDisplay attribute={'wah'}/>
            </Item>
        </Grid>
        <Grid item xs={6} sm={4}>
            <Item>
                <AttributeDisplay attribute={'wil'}/>
            </Item>
        </Grid>
        <Grid item xs={6} sm={4}>
            <Item>
                <AttributeDisplay attribute={'cha'}/>
            </Item>
        </Grid>
    </Grid>
}